import React from 'react';
import { Col, Container, Row } from 'reactstrap';

// Import Images
import processArrow from "../../../assets/images/landing/process-arrow-img.png";

const WorkProcess = () => {
    return (
        <React.Fragment>
            <section className="section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-5">
                                <h3 className="mb-3 fw-bold">How Our POS System Works</h3>
                                <p className="text-muted mb-4 ff-secondary">
                                    A simple and efficient workflow designed for restaurants, cafés, and retail businesses 
                                    to streamline operations—from taking orders to generating reports.
                                </p>
                            </div>
                        </Col>
                    </Row>

                    <Row className="text-center">
                        <Col lg={4}>
                            <div className="process-card mt-4">
                                <div className="process-arrow-img d-none d-lg-block">
                                    <img src={processArrow} alt="" className="img-fluid" />
                                </div>
                                <div className="avatar-sm icon-effect mx-auto mb-4">
                                    <div className="avatar-title bg-transparent text-success rounded-circle h1">
                                        <i className="ri-restaurant-line"></i>
                                    </div>
                                </div>

                                <h5>1. Take Orders</h5>
                                <p className="text-muted ff-secondary">
                                    Waiters or cashiers quickly take dine-in, takeaway, or online orders using POS or mobile devices.
                                </p>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="process-card mt-4">
                                <div className="process-arrow-img d-none d-lg-block">
                                    <img src={processArrow} alt="" className="img-fluid" />
                                </div>
                                <div className="avatar-sm icon-effect mx-auto mb-4">
                                    <div className="avatar-title bg-transparent text-success rounded-circle h1">
                                        <i className="ri-printer-line"></i>
                                    </div>
                                </div>

                                <h5>2. Send to Kitchen</h5>
                                <p className="text-muted ff-secondary">
                                    Orders are instantly sent to kitchen display screens or printers, reducing errors and speeding up service.
                                </p>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="process-card mt-4">
                                <div className="avatar-sm icon-effect mx-auto mb-4">
                                    <div className="avatar-title bg-transparent text-success rounded-circle h1">
                                        <i className="ri-cash-line"></i>
                                    </div>
                                </div>

                                <h5>3. Bill & Track</h5>
                                <p className="text-muted ff-secondary">
                                    Generate bills, accept payments, and track sales and inventory in real-time with insightful reports.
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default WorkProcess;
